import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
    selector: 'app-message',
    templateUrl: './message.component.html'
})
export class MessageComponent implements OnInit {

    @Input() title = 'An error occured.';

    @Input() text = 'Please try again later.';

    @Input() severity = 'info';

    @Input() border = true;

    @Input() dismissible = false;
    
    @Output() dismiss = new EventEmitter<boolean>();

    ngOnInit(): void {
    }

    triggerDismiss(): void {
        this.dismiss.emit(true);
    }
}
